import { render, staticRenderFns } from "./BaseProtocolInfo.vue?vue&type=template&id=ed495654&scoped=true"
import script from "./BaseProtocolInfo.vue?vue&type=script&lang=js"
export * from "./BaseProtocolInfo.vue?vue&type=script&lang=js"
import style0 from "./BaseProtocolInfo.vue?vue&type=style&index=0&id=ed495654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed495654",
  null
  
)

export default component.exports